import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#f0f0f0] pt-16 pb-8 px-8 mt-auto">
      <div className="max-w-7xl mx-auto">
        
        {/* 上半部分：四列链接网格 */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
          {/* 第1列：产品 */}
          <div className="flex flex-col gap-3">
            <h4 className="font-bold text-gray-900 mb-2">{t('footer.products')}</h4>
            <Link to="#" className="text-sm text-gray-600 hover:text-black">{t('footer.hygroMax')}</Link>
            <Link to="#" className="text-sm text-gray-600 hover:text-black">{t('footer.hygroMini')}</Link>
            <Link to="#" className="text-sm text-gray-600 hover:text-black">{t('footer.binArray')}</Link>
            <Link to="#" className="text-sm text-gray-600 hover:text-black">{t('footer.accessories')}</Link>
          </div>

          {/* 第2列：技术 */}
          <div className="flex flex-col gap-3">
            <h4 className="font-bold text-gray-900 mb-2">{t('footer.tech')}</h4>
            <Link to="#" className="text-sm text-gray-600 hover:text-black">{t('footer.iotArch')}</Link>
            <Link to="#" className="text-sm text-gray-600 hover:text-black">{t('footer.aiMaintenance')}</Link>
            <Link to="#" className="text-sm text-gray-600 hover:text-black">{t('footer.openSource')}</Link>
            <Link to="#" className="text-sm text-gray-600 hover:text-black">{t('footer.docs')}</Link>
          </div>

          {/* 第3列：开发者 */}
          <div className="flex flex-col gap-3">
            <h4 className="font-bold text-gray-900 mb-2">{t('footer.developers')}</h4>
            <Link to="#" className="text-sm text-gray-600 hover:text-black">{t('footer.devCenter')}</Link>
            <Link to="#" className="text-sm text-gray-600 hover:text-black">{t('footer.apiSdk')}</Link>
            <Link to="#" className="text-sm text-gray-600 hover:text-black">{t('footer.community')}</Link>
            <Link to="#" className="text-sm text-gray-600 hover:text-black">{t('footer.github')}</Link>
          </div>

          {/* 第4列：公司 */}
          <div className="flex flex-col gap-3">
            <h4 className="font-bold text-gray-900 mb-2">{t('footer.company')}</h4>
            <Link to="#" className="text-sm text-gray-600 hover:text-black">{t('footer.aboutUs')}</Link>
            <Link to="#" className="text-sm text-gray-600 hover:text-black">{t('footer.careers')}</Link>
            <Link to="#" className="text-sm text-gray-600 hover:text-black">{t('footer.news')}</Link>
            <Link to="#" className="text-sm text-gray-600 hover:text-black">{t('footer.contact')}</Link>
            <Link to="#" className="text-sm text-gray-600 hover:text-black">{t('footer.events')}</Link>
          </div>
        </div>

        {/* 下半部分：版权、协议与社交图标 */}
        <div className="flex flex-col md:flex-row items-center justify-between pt-8 border-t border-gray-300">
          <div className="text-sm text-gray-500 mb-4 md:mb-0 flex gap-4">
            {/* 使用 i18next 的插值功能传入当前年份 */}
            <span>{t('footer.copyright', { year: currentYear })}</span>
            <span className="hidden md:inline">|</span>
            <Link to="#" className="hover:text-black transition-colors">{t('footer.privacy')}</Link>
            <span>|</span>
            <Link to="#" className="hover:text-black transition-colors">{t('footer.terms')}</Link>
          </div>

          {/* 社交媒体图标占位 (后期可用 Lucide-react 或自定义 SVG 替换) */}
          <div className="flex gap-4 items-center">
             <div className="w-5 h-5 bg-gray-400 rounded-sm hover:bg-black transition-colors cursor-pointer" title="LinkedIn"></div>
             <div className="w-5 h-5 bg-gray-400 rounded-sm hover:bg-black transition-colors cursor-pointer" title="Twitter"></div>
             <div className="w-5 h-5 bg-gray-400 rounded-full hover:bg-black transition-colors cursor-pointer" title="GitHub"></div>
             {/* 底部右下角的设计稿叶子图标占位 */}
             <div className="w-8 h-8 ml-4 opacity-30 bg-cover" style={{ backgroundImage: `url(${t('footer.leafIconImagePath')})` }}></div>
          </div>
        </div>

      </div>
    </footer>
  );
};